import { FeedbackToastHandler } from '../../config/errors/feedback';
import { AuthenticatedApiRepository } from './authenticated_base_repository';
import { OrderBrief, OrderDetails } from '../../data/types/orders';
import { API_BASE } from '../../config/constants';
import { Package } from '../../data/types/shipping';
import { ORDERS_MESASGES } from '../constants/messages';
export class OrdersApiRepository extends AuthenticatedApiRepository {
  protected static instance: OrdersApiRepository | null = null;
  protected constructor(axiosInstance: any) {
    super(axiosInstance);
  }

  public static getInstance(axiosInstance: any): OrdersApiRepository {
    if (!OrdersApiRepository.instance) {
      OrdersApiRepository.instance = new OrdersApiRepository(axiosInstance);
    }
    return OrdersApiRepository.instance;
  }
  getStoreOrdersOfStatus = async (
    storeId: number,
    statuses: number[],
    page = 1,
    limit = 1000,
  ) => {
    // TODO fix any
    try {
      const url = `/stores/${storeId}/orders/filter_by_status/?order_asc=yes&page=${page}&per_page=${limit}${
        statuses?.length ? statuses.map((status) => `&status=${status}`) : ''
      }`;
      const res = await FeedbackToastHandler(
        this.sendRequest('GET', url, {
          baseApiUrl: API_BASE,
          mustEndWithSlash: false,
        }),
        {
          noSuccessMsg: true,
          noFailureMsg: false,
        },
      );
      return res.data ? (res.data.result as OrderBrief[]).toReversed() : [];
    } catch (error: any) {
      return false; // Add this line to return undefined in case of an error
    }
  };

  getOrders = async ({
    order_asc = true,
    statuses,
    store_id,
    customer_id,
    shift_id,
    page = 1,
    per_page = 100000,
  }: {
    order_asc?: boolean;
    statuses?: number[];
    store_id?: number;
    customer_id?: number;
    shift_id?: number;
    page?: number;
    per_page?: number;
  }) => {
    try {
      const url = `/orders/filter_by_status/?${
        order_asc ? 'order_asc=yes' : ''
      }${statuses ? `&status=${statuses.join('&status=')}` : ''}${
        customer_id ? `&customer_id=${customer_id}` : ''
      }${store_id ? `&store_id=${store_id}` : ''}${
        shift_id ? `&shift_id=${shift_id}` : ''
      }&page=${page}&per_page=${per_page}`;

      const res = await FeedbackToastHandler(
        this.sendRequest('GET', url, {
          baseApiUrl: API_BASE,
          mustEndWithSlash: false,
        }),
        {
          noSuccessMsg: true,
          noFailureMsg: false,
          customPendingMsg: 'Loading orders...',
        },
      );
      return res.data ? (res.data.result as OrderBrief[]).toReversed() : [];
    } catch (error: any) {
      return false; // Add this line to return undefined in case of an error
    }
  };
  getOrderDetailsByID = async ({
    store_id,
    order_id,
  }: {
    store_id?: number;
    order_id: number;
  }) => {
    try {
      const res = await FeedbackToastHandler(
        this.sendRequest(
          'GET',
          `${store_id ? `/stores/${store_id}` : ''}/orders/${order_id}/`,
        ),
        {
          noSuccessMsg: true,
          noPendingMsg: true,
        },
      );
      if (res.status !== 200) {
        throw new Error('Something went wrong');
      }
      return res.data.order as OrderDetails;
    } catch (error: any) {
      return false; // Add this line to return undefined in case of an error
    }
  };

  acceptOrderByID = async (store_id: number, order_id: number) => {
    try {
      const res = await FeedbackToastHandler(
        this.sendRequest(
          'PUT',
          `/stores/${store_id}/orders/${order_id}/accept_order/`,
        ),
        {
          noPendingMsg: false,
          noSuccessMsg: false,
          noFailureMsg: false,
          customSuccessMsg: ORDERS_MESASGES.OrderAccepted,
        },
      );
      return res.status === 202;
    } catch (error: any) {
      return false; // Add this line to return undefined in case of an error
    }
  };

  rejectOrderByID = async (
    store_id: number,
    order_id: number,
    reason: string,
  ) => {
    try {
      const res = await FeedbackToastHandler(
        this.sendRequest(
          'PUT',
          `/stores/${store_id}/orders/${order_id}/reject_order/`,
          {
            baseApiUrl: API_BASE,
            mustEndWithSlash: true,
            data: { reason: reason },
          },
        ),
        {
          noSuccessMsg: false,
          noFailureMsg: false,
          customSuccessMsg: ORDERS_MESASGES.OrderRejected,
        },
      );

      return res.status === 202;
    } catch (error: any) {
      return false; // Add this line to return undefined in case of an error
    }
  };

  markOrderAsReadyByID = async (
    store_id: number,
    order_id: number,
    packages: Package[],
  ) => {
    try {
      const res = await FeedbackToastHandler(
        this.sendRequest(
          'PUT',
          `/stores/${store_id}/orders/${order_id}/set_ready_for_shipping/`,
          {
            baseApiUrl: API_BASE,
            mustEndWithSlash: true,
            data: { packages: packages },
          },
        ),
        {
          noPendingMsg: false,
          noSuccessMsg: false,
          noFailureMsg: false,
          customSuccessMsg: ORDERS_MESASGES.TrackingNumberAdded,
        },
      );
      return res.status === 202;
    } catch (error: any) {
      return false; // Add this line to return undefined in case of an error
    }
  };
  cancelOrder = async (order_id: number) => {
    try {
      const res = await FeedbackToastHandler(
        this.sendRequest('PUT', `/orders/${order_id}/cancel/`),
        {
          noPendingMsg: false,
          noSuccessMsg: false,
          noFailureMsg: false,
          customSuccessMsg: ORDERS_MESASGES.OrderCancelled,
        },
      );
      return res.status === 202;
    } catch (error: any) {
      return false; // Add this line to return undefined in case of an error
    }
  };
}
